export enum CodigoPastaEnum{
  cpMp3Upload = 1,
  cpSpotUpload = 2,
}
